import React, { useReducer, useEffect, useContext} from "react";
import controlContext from "./controlContex";
import { getAllControl, addControl, updateControl, deleteControl } from "../../api/control";
import controlReducer from "./controlReducer";
//Types
import { 
    ACTUALIZAR_LIST_CONTROL,
  } from "./controlActions";
import authContext from "../authentication/authContex";

const ControlState = props =>{

    const initialState = {
        controlList: []
     };

    const [state, dispatch] = useReducer(controlReducer, initialState);
    const ahContext = useContext(authContext)
    const {usuario,verificarTenant} = ahContext;

    const actualizarControlList = async () => {
        try{
            const resp = await getAllControl();
            
            const control = resp.data.data;

            dispatch({
                type: ACTUALIZAR_LIST_CONTROL,
                payload: control
            });
            
            return control;
        }catch(err){
            console.log(err)
        }

    };

    const agregarControl = async (dato) => {
        try{
            // Luego, puedes enviar estos datos al backend usando una función llamada addControl
            const resp = await addControl(dato);
            const control = resp.data.data;
            return control;
        }catch(err){
            console.log(err);
            return null;
            
        }
        
    };

    const modificarControl = async (dato) => {
        try{
            const resp = await updateControl(dato);
            const activo = resp.data.data;
            return activo;
        }catch(err){
            console.log(err)
            return null;
        }
    }

    const eliminarControl = async (id,checklistID) => {
        try{
            const resp = await deleteControl(id, checklistID);
            return resp;
        }catch(err){
            console.log(err)
        }
    }

    useEffect(() => {
        if(usuario != null) actualizarControlList();
    },[usuario])

    return(
        <controlContext.Provider
            value={{
                controlList: state.controlList,
                actualizarControlList,
                agregarControl,
                modificarControl,
                eliminarControl
            }}
        >
            {props.children}
        </controlContext.Provider>
    )

}

export default ControlState;